import React from 'react'

export default function App18() {
  return (
    <div>详情页测试测试jekins推送自动部署</div>
  )
}
